export const medalMemberOption = {
  border: true,
  stripe: true,
  menu: false,
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  header: false,
  column: [
    {
      label: '姓名',
      prop: 'recordToRealname',
      overHidden: true,
    },
	  {
      label: '昵称',
      prop: 'recordToNickname',
      overHidden: true,
    },
    {
      label: '员工号',
      prop: 'recordToUnionId',
      overHidden: true,
    },
    {
      label: '发放人',
      prop: 'recordByName',
      overHidden: true,
    },
    {
      label: '发放时间',
      prop: 'recordTime',
      overHidden: true,
      sortable: true,
    },
  ]
}
